
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/promocoes/loja/[storeSlug]",
      function () {
        return require("private-next-pages/promocoes/loja/[storeSlug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/promocoes/loja/[storeSlug]"])
      });
    }
  